<template lang="pug">
	section.section.main-section
		.container
			title-comp(:name="$t('signup.confirm')")
			.form-container.form-login
				.field
					p.has-text-centered
						| {{ $t('signup.confirm_help', { 'mail': signupEmail }) }}

				.field
					p.control
						input.input(type="text" :placeholder="$t('placeholder.confirm_code')" maxlength="10" v-model="confirm_code")
					p.has-text-centered(v-if="devCode")
						| {{ devCode }}

				.field.margin-top-md(v-if="!errorExpired")
					p.control.has-text-centered
						button.button.is-primary(type="button" v-bind:class="buttonClass" @click="submitSignupConfirm")
							| {{ $t('button.continue') }}

				article.message.is-danger(v-if="errorCode" transition="fade")
					.message-body
						| {{ $t('alert.missing_confirm_code') }}
				article.message.is-danger(v-else-if="errorAuth" transition="fade")
					.message-body
						| {{ $t('alert.invalid_login') }}
				article.message.is-danger(v-else-if="errorExpired" transition="fade")
					.message-body
						| {{ $t('alert.expired_confirm_code') }}
						.margin-top-md
							p.control.has-text-centered
								button.button.is-primary(type="button" v-bind:class="buttonClass" @click="goBack")
									| {{ $t('button.go_back') }}

</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'
import { MailIcon, KeyIcon, BriefcaseIcon, LockIcon, EyeOffIcon, EyeIcon } from 'vue-feather-icons'

export default {
	components: {
		TitleComp: TitleComponent,
		MailIcon,
		LockIcon,
		BriefcaseIcon,
		KeyIcon,
		EyeOffIcon,
		EyeIcon
	},
	data() {
		return {
			confirm_code: '',
			hidden      : true,
			errorCode   : false,
			errorPage   : false,
			errorExpired: false,
			errorAuth   : false
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		signupToken() {
			return this.$store.state.auth.signupToken
		},
		userPromoCode() {
			return this.$store.state.user.userPromoCode
		},
		signupEmail() {
			return this.$store.state.auth.signupEmail
		},
		devCode() {
			return this.$store.state.auth.confirmCode
		},
		companyCode() {
			return this.$store.state.auth.companyCode
		},
		loading() {
			return this.$store.state.auth.loading
		},
		buttonClass() {
			return { 'is-loading': this.loading }
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.signup") + ' | ' + this.$t("title.home") })
		if (this.accessToken) {
			this.$router.replace('/')
		}

		if (!this.signupToken || !this.signupEmail) {
			this.$router.replace('/')
		}
	},
	methods: {
		submitSignupConfirm() {
			if (!this.confirm_code) {
				this.errorCode = true
				return
			}

			this.$store.dispatch('auth/submitSignupConfirm', {
				code: this.confirm_code
			})
				.then(response => {
					if (response) {
						this.submitPromoCode()
					}
				})
				.catch(err => {
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 403:
								this.errorAuth = true
								break
							case 500:
								this.errorPage = true
								break
							case 419:
								this.errorExpired = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
		},
		submitPromoCode() {
			this.$store.commit('user/SET_USER_AUTH', 'signup')
			if (!this.userPromoCode || !this.accessToken) {
				return this.$alert(this.$t('alert.signed_up'), null, 'success')
					.then(res => {
						this.$router.replace('/profile')
					})
			}

			this.$store.dispatch('user/submitPromoCode', {
				'token': this.accessToken,
				'code':  this.userPromoCode
			}).then(res => {
				return this.$alert(this.$t('alert.promo_code_activated_signup'), null, 'success');
			}).then(() => {
				this.$router.replace('/profile')
			}).catch(err => {
				if (err.response && err.response.status) {
					console.warn(err.response.status)
				}

				this.$router.replace('/profile')
			})
		},
		goBack() {
			this.$router.replace('/promo-code')
		}
	},
	watch: {
		confirm_code() {
			this.errorCode = false
		}
	}
}
</script>
